import React, { memo } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { CreateContractorNoteButton } from './CreateContractorNoteButton'
import { colors } from 'src/theme'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'

interface Props {
  contractorId: string
  refreshContractorNotes(): void
}

export const EmptyNotesComponent = ({ contractorId, refreshContractorNotes }: Props) => {
  const { hasPermission } = useCheckPermissions()

  return (
    <div
      css={tw`bg-white rounded-2xl px-4 pt-6 pb-4 flex flex-col items-center h-auto justify-center`}
    >
      <img src={EmptyImage} alt="empty activity log" css={tw`w-[210px] mb-4`} />
      <Typography variant="h4" color="black" css={tw`mb-0.5`}>
        No notes yet.
      </Typography>
      <Typography
        textAlign="center"
        variant="body2"
        color={colors.GRAY_COOL_GRAY}
        css={tw`w-[270px] mb-4`}
      >
        Add a note to start tracking the contractor's progress, status, or key details
      </Typography>
      {hasPermission(UserPermission.ContractorNotesCreate) && (
        <CreateContractorNoteButton
          contractorId={contractorId}
          refreshContractorNotes={refreshContractorNotes}
        />
      )}
    </div>
  )
}

export const EmptyNotes = memo(EmptyNotesComponent)
